import loadAgendaItemsAroundPivot from './internal/loadAgendaItemsAroundPivot';
import loadAgendaItemsForScroll from './internal/loadAgendaItemsForScroll';
import reloadAgendaItems from './internal/reloadAgendaItems';
import { loadAgendaView } from '../actions/publicActions';
import { orchestrator } from 'satcheljs';

/**
 * Orchestrator which listens to the event loadAgendaView and calls the appropriate function based on actionMessage.
 */
export default orchestrator(loadAgendaView, actionMessage => {
    const { pivotDate, scrollDirection, eventsAddedOrRemoved } = actionMessage;
    if (pivotDate) {
        loadAgendaItemsAroundPivot(pivotDate);
    } else if (scrollDirection) {
        loadAgendaItemsForScroll(scrollDirection);
    } else {
        reloadAgendaItems(eventsAddedOrRemoved);
    }
});
